import { restaurantTypes, userTypes } from "../types";
import { tableTypes } from "../types";

const initialstate = {
  allRestaurants: [],
  restaurantTableTypes: [],
};

const restaurantReducer = (state = initialstate, action) => {
  const getData = () => action.payload?.data;

  switch (action.type) {
    case restaurantTypes.GET_ALL_RESTAURANTS_SUCCESS:
      return {
        ...state,
        allRestaurants: getData().data,
      };
    case userTypes.LOGOUT_USER:
      return { ...initialstate };

    case tableTypes.GET_ALL_RESTAURANT_TABLETYPES:
      return {
        ...state,
        restaurantTableTypes: [],
      };
    case tableTypes.GET_ALL_RESTAURANT_TABLETYPES_SUCCESS:
      return {
        ...state,
        restaurantTableTypes: getData()?.data,
      };
    default:
      return state;
  }
};

export default restaurantReducer;
